/**
 * 卖家商品行(W-8)。视觉对齐 design/seller-products.html `.list-item`。
 * 行操作态可见性来自 rowActions();**无删除入口**;REJECTED 渲染驳回原因卡(截 80)。
 */
import type { SellerProductListItem } from '@/api/products';
import { STATUS_LABEL, UNIT_LABEL, formatPriceYuan } from '@/lib/productLabels';
import { previewRejection, rowActions } from './logic';

export function SellerProductRow({
  item,
  onEdit,
  onOffline,
  onRepublish,
  onDelete,
}: {
  item: SellerProductListItem;
  onEdit: (id: string) => void;
  onOffline: (item: SellerProductListItem) => void;
  onRepublish: (item: SellerProductListItem) => void;
  onDelete: (item: SellerProductListItem) => void;
}) {
  const a = rowActions(item.status);
  const badgeClass = item.status === 'ONLINE' ? 'badge badge-primary' : 'badge badge-muted';

  return (
    <div className="col" style={{ gap: 'var(--space-2)' }}>
      <div className="list-item" style={{ alignItems: 'center' }}>
        {item.coverImage ? (
          <img
            src={item.coverImage}
            alt={item.title}
            style={{ width: 96, height: 72, borderRadius: 'var(--radius-md)', objectFit: 'cover', flexShrink: 0 }}
          />
        ) : (
          <div
            className="avatar"
            style={{ width: 96, height: 72, borderRadius: 'var(--radius-md)', flexShrink: 0 }}
          >
            无图
          </div>
        )}

        {/* 信息区:占中部弹性空间;minWidth:0 允许标题过长时省略而非撑破布局 */}
        <div className="col" style={{ flex: 1, minWidth: 0, gap: 'var(--space-2)' }}>
          <div className="row gap-2" style={{ alignItems: 'center', minWidth: 0 }}>
            <span
              style={{
                fontWeight: 'var(--weight-medium)',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                minWidth: 0,
              }}
            >
              {item.title}
            </span>
            <span className={badgeClass} style={{ flexShrink: 0 }}>
              {STATUS_LABEL[item.status]}
            </span>
          </div>
          <div className="row gap-4" style={{ alignItems: 'baseline' }}>
            <span className="price" style={{ fontSize: 'var(--text-lg-size)' }}>
              {formatPriceYuan(item.price)}
              <span className="unit">/{UNIT_LABEL[item.unit] ?? item.unit}</span>
            </span>
            <span className="xs muted">已售 {item.salesCount ?? 0}</span>
          </div>
        </div>

        {/* 操作区:marginLeft:auto 顶到最右,不换行,充分利用宽屏横向空间 */}
        <div className="row gap-2" style={{ flexShrink: 0, marginLeft: 'auto' }}>
          <button
            type="button"
            className={a.editPrimary ? 'btn btn-primary' : 'btn btn-secondary'}
            disabled={a.editDisabled}
            onClick={() => onEdit(item.id)}
          >
            {a.editDisabled ? '审核中无法编辑' : '编辑'}
          </button>
          {a.showOffline && (
            <button type="button" className="btn btn-destructive" onClick={() => onOffline(item)}>
              下架
            </button>
          )}
          {a.showRepublish && (
            <button type="button" className="btn btn-primary" onClick={() => onRepublish(item)}>
              重新上架
            </button>
          )}
          {/* 删除:软删除,各状态均可(次要破坏性操作,ghost + 危险色,弱于「下架」) */}
          <button
            type="button"
            className="btn btn-ghost"
            style={{ color: 'var(--color-destructive)' }}
            onClick={() => onDelete(item)}
          >
            删除
          </button>
        </div>
      </div>

      {a.showRejection && item.rejectionReason && (
        <div
          className="card card-pad sm"
          style={{ background: 'var(--color-secondary)', boxShadow: 'none' }}
        >
          <span className="muted">驳回原因:</span>
          {previewRejection(item.rejectionReason)}
        </div>
      )}
    </div>
  );
}
